module.exports = __webpack_public_path__ + "src/assets/games/14/149.jpg";